import React, { FC } from 'react'
import { IAutocompleteOption } from 'transfix-ui/components/Autocomplete'
import {
  Autosuggest,
  getAutosuggestOptions,
  IAutosuggestWrapperProps,
} from 'transfix-ui/components/Autosuggest'
import { useTeamMemberContext } from 'apps/fleet-planner/context/TeamMemberContext'
import * as Types from 'apps/fleet-planner/types'
import { TextInputIconType } from 'components/atoms'

interface ITeamMemberAutosuggestProps extends IAutosuggestWrapperProps<Types.ITeamMember> {}

export const TeamMemberAutocomplete: FC<ITeamMemberAutosuggestProps> = ({ onChange, value }) => {
  const { teamMembers = [] } = useTeamMemberContext()

  const changeHandler = (option: IAutocompleteOption | undefined) => {
    const newTeamMember = teamMembers.find(member => member.id === Number(option?.id))
    onChange(newTeamMember)
  }

  const teamMembersOptionsList = getAutosuggestOptions({
    options: teamMembers,
    groupIndex: 1,
    mapOption: ({ email, firstName, id, lastName }: Types.ITeamMember) => ({
      id: `${id}`,
      text: `${firstName} ${lastName}${email ? ` · ${email}` : ''}`,
    }),
  })

  return (
    <Autosuggest
      options={teamMembersOptionsList}
      onChange={changeHandler}
      placeholder='Search your current team members'
      value={value}
      icon={TextInputIconType.search}
      renderOptionType='withAvatar'
      large
      autoSelect
      clearable
      autoHighlight
    />
  )
}
